@if (opened()) {
<div
  class="modal-wrapper text-start"
  @backdrop
  (mousedown)="onBackdropPointerDown($event)"
  (@backdrop.done)="opened() ? onOpenEnd.emit() : onCloseEnd.emit()"
>
  <div
    class="modal"
    [class.xl]="big"
    [class.sm]="small"
    [class.md]="medium"
    [class.shaking]="shaking()"
    [class.dynamic]="dynamic"
    @modal
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    @if (!hideHeader) {
      <div class="modal-header">
        <div class="d-flex align-items-center">
          @if (icon) {
            <fa-icon [icon]="icon" size="lg" class="me-2"></fa-icon>
          }
          <h4 [innerHTML]="label"></h4>
        </div>
        @if (closeable) {
          <span (click)="close($event)">
            <div class="icon-wrapper">
              <fa-icon [icon]="faTimes" size="lg"></fa-icon>
            </div>
          </span>
        }
      </div>
    }
    <div class="modal-content" [class.dynamic]="dynamic">
      <ng-content></ng-content>
    </div>
    @if (!hideFooter && !(screenService.isMobile && closeable && !footer)) {
      <div class="modal-footer gap-3 flex-wrap">
        @if (!footer && !screenService.isMobile && closeable) {
          <button class="ct-btn ct-btn-white-grey" (click)="close($event)">
            {{ 'ct-library.modal.button-close' | transloco }}
          </button>
        }
        @if (footer) {
          <ng-container [ngTemplateOutlet]="footer"></ng-container>
        }
      </div>
    }
  </div>
</div>
}
